import {
    getUserAccountList,
    handleKeyDown,
    uploadFiles,
} from "_services";
import {
    CommonCanvas,
    CommonDatePicker,
    CommonInput,
    CustomSelect,
    SkeletonInput,
} from "components";
import { UserContext } from "context";
import { addTransationFreight } from "features";
import { errorSchema, utils } from "helper";
import AddAccountingAccount from "modals/AddAccountingAccount";
import React, { useContext, useEffect, useState } from "react";
import toast from "react-hot-toast";
import { IoCloseCircle } from "react-icons/io5";
import { useDispatch } from "react-redux";
import StorageService from "utils/StorageServices/StorageServices";

const InterFirmAdvancePay = (props) => {
    const { venderDetailsFun = () => { }, interFirmTransDetails } = props;

    const initiFrom = {
        category: "",
        sub_category: "",
        expense_category: "",
        amount: "",
        txn_date: new Date(),
        account_category: "",
        account_sub_category: "",
        account_id: "",
        to_account_category: "",
        to_account_sub_category: "",
        to_account_id: "",
        description: "",
        isCheck: false,
        vendor_account: "",
        lr_id: "",
        trip_id: props?.tripId,
        branch_id: "",
        company_id: StorageService.getCompanyId(),
        vehicle_id: "",
        file: [],
    };

    const dispatch = useDispatch();
    const {
        masterData,
        globTripDetails,
        bankDetails,
        setBankDetails,
        modalZIndex,
    } = useContext(UserContext);

    const [form, setForm] = useState(initiFrom);
    const [formError, setFormError] = useState("");
    const [freightTypeList, setFreightTypeList] = useState([]);
    const [freigtAccount, setFreigtAccount] = useState([]);
    const [accountList, setAccountList] = useState([]);
    const [toAccountList, setToAccountList] = useState([]);
    const [isLoadding, setIsLoadding] = useState(false);
    const [isLoaddingforsave, setIsLoaddingForSave] = useState(false);
    const [accountLoading, setAccountLoading] = useState(false);
    const [accountToLoading, setAccountToLoading] = useState(false);

    const [loading, setLoading] = useState(false);
    const [accountAddShow, setAccountAddShow] = useState(false);
    const [bankRequiredDetails, setBankRequiredDetails] = useState({});
    const [accountType, setAccountType] = useState();
    const balance = props?.isOpen?.firm_freight_summary?.balance;

    function checkBalance(balance) {
        if (balance > 0) {
            return "plus";   // Positive balance
        } else if (balance < 0) {
            return "minus";  // Negative balance
        } else {
            return "zero";   // Exactly 0
        }
    }

    useEffect(() => {
        getMasterFreight();
    }, [props?.isOpenFreight?.open]);


    useEffect(() => {
        if (accountType) {
            setForm({ ...form, account_id: "", to_account_id: "" });
        }
    }, [accountType]);

    useEffect(() => {

        if (form?.account_sub_category) {
            setForm((u) => ({ ...u, to_account_sub_category: form?.account_sub_category }))
        }

        if (form?.account_sub_category == 14) {
            setForm((u) => ({ ...u, to_account_sub_category: "" }))
        }

    }, [form?.account_sub_category])

    useEffect(() => {
        if (form?.sub_category == 2) {
            setForm((prev) => {
                const updatedAmount =
                    form?.sub_category == 2
                        ? prev?.amount || balance || 0
                        : prev?.amount;

                return {
                    ...prev,
                    amount: updatedAmount,
                };
            });
        }
    }, [form?.sub_category]);

    // ✅ Update FROM account useEffect
    useEffect(() => {
        if (form?.account_sub_category && form?.account_category && freigtAccount.length) {
            if (form?.account_id === "") {
                getFromAccountListHandler();
            }
        }
    }, [
        form?.account_sub_category,
        form?.account_category,
        freigtAccount,
        form?.account_id,
        form?.sub_category,
    ]);

    // ✅ Update TO account useEffect
    useEffect(() => {
        if (form?.to_account_sub_category && form?.to_account_category && freigtAccount.length && form?.account_id) {
            if (form?.to_account_id === "") {
                getToAccountListHandler();
            }
        } else {
            setToAccountList([]);
        }
    }, [
        form?.to_account_sub_category,
        form?.to_account_category,
        freigtAccount,
        form?.account_id,
        form?.sub_category,
    ]);


    // Add this useEffect to reset to_account_id when to_account_sub_category changes
    useEffect(() => {
        if (form?.to_account_sub_category) {
            setForm(prev => ({
                ...prev,
                to_account_id: ""
            }));
        }
    }, [form?.to_account_sub_category]);


    const getMasterFreight = async () => {
        try {
            const details = masterData?.supplier_freights?.sub_type?.map((item) => {
                return {
                    label: item?.name,
                    value: item?.id,
                    id: item?._id,
                    status: item?.status,
                    category_id: masterData?.supplier_freights?.id,
                    type: masterData?.supplier_freights?.type,
                };
            });

            const detailsAccount = masterData?.market_account_category?.sub_category
                ?.filter((k) => ![10, 27].includes(k.id))
                .map((item) => {
                    return {
                        label: item?.name,
                        value: item?.id,
                        category_id: masterData?.market_account_category?.id,
                    };
                });

            const order = [3, 2, 14];
            const sortedData = detailsAccount.sort(
                (a, b) => order.indexOf(a.value) - order.indexOf(b.value)
            );

            if (sortedData && details) {
                setForm({
                    ...form,
                    trip_id: props?.tripId,
                    category:
                        details[props?.isOpenFreight?.type === "freight" ? 0 : 1]
                            ?.category_id,
                    sub_category:
                        details[props?.isOpenFreight?.type === "freight" ? 0 : 1]?.value,
                    account_category: sortedData[0]?.category_id,
                    account_sub_category: sortedData[0]?.value,
                    to_account_category: sortedData[0]?.category_id,
                    to_account_sub_category: sortedData[0]?.value,
                });

                setFreigtAccount(sortedData);
                setFreightTypeList(details);
            }
        } catch (error) {
            console.error("Error fetching master freight:", error);
        }
    };

    // const getAccountListHandler = async (newParam = "") => {
    //     setAccountLoading(true);
    //     try {
    //         const res = await getUserAccountList({
    //             company_id: StorageService?.getCompanyId(),
    //             category_id: parseInt(
    //                 newParam === "from" ? form?.account_category : form?.to_account_category
    //             ),
    //             sub_category_id: parseInt(
    //                 newParam === "from" ? form?.account_sub_category : form?.to_account_sub_category
    //             ),
    //             firm_id: newParam === "from" ? props?.isOpen?.branch_firm?._id : props?.isOpen?.vehicle_firm?._id
    //         });

    //         if (res?.responseCode === 200) {
    //             setAccountLoading(false);
    //             const details = res?.data?.account_list?.map((item) => {
    //                 return {
    //                     ...item,
    //                     label: item?.name,
    //                     value: item?._id,
    //                 };
    //             });

    //             if (newParam === "from") {
    //                 setAccountList(details);
    //             } else if (newParam === "to") {
    //                 setToAccountList(details);
    //             }

    //             if (details?.length) {
    //                 const lastItem = details[details.length - 1];
    //                 setForm((prev) => {
    //                     const updatedAmount =
    //                         prev?.sub_category == 2
    //                             ? prev?.amount || globTripDetails?.freight_summary?.balance || 0
    //                             : prev?.amount;

    //                     return {
    //                         ...prev,
    //                         [newParam === "from" ? "account_id" : "to_account_id"]:
    //                             newParam === "new" ? lastItem?.value : details[0]?.value,
    //                         amount: updatedAmount,
    //                     };
    //                 });
    //                 setBankRequiredDetails(newParam === "new" ? lastItem : details[0]);
    //             } else {
    //                 setForm((prev) => ({
    //                     ...prev,
    //                     [newParam === "from" ? "account_id" : "to_account_id"]: "",
    //                 }));
    //             }
    //         } else {
    //             setAccountLoading(false);
    //             if (newParam === "from") {
    //                 setAccountList([]);
    //             } else {
    //                 setToAccountList([]);
    //             }
    //         }
    //     } catch (error) {
    //         setAccountLoading(false);
    //         if (newParam === "from") {
    //             setAccountList([]);
    //         } else {
    //             setToAccountList([]);
    //         }
    //     }
    // };

    // ✅ Separate function for FROM account
    const getFromAccountListHandler = async (isNewAccount = false) => {
        setAccountLoading(true);
        try {
            const res = await getUserAccountList({
                company_id: StorageService?.getCompanyId(),
                category_id: parseInt(form?.account_category),
                sub_category_id: parseInt(form?.account_sub_category),
                firm_id: props?.isOpen?.branch_firm?._id
            });

            if (res?.responseCode === 200) {
                setAccountLoading(false);
                const details = res?.data?.account_list?.map((item) => ({
                    ...item,
                    label: item?.name,
                    value: item?._id,
                }));

                setAccountList(details);

                if (details?.length) {
                    const selectedItem = isNewAccount ? details[details.length - 1] : details[0];

                    setForm((prev) => {
                        const updatedAmount =
                            prev?.sub_category == 2
                                ? prev?.amount || globTripDetails?.freight_summary?.balance || 0
                                : prev?.amount;

                        return {
                            ...prev,
                            account_id: selectedItem?.value,
                            amount: updatedAmount,
                        };
                    });

                    setBankRequiredDetails(selectedItem);
                } else {
                    setForm((prev) => ({
                        ...prev,
                        account_id: "",
                    }));
                }
            } else {
                setAccountLoading(false);
                setAccountList([]);
            }
        } catch (error) {
            setAccountLoading(false);
            setAccountList([]);
            console.error("Error fetching from account list:", error);
        }
    };

    // ✅ Separate function for TO account
    const getToAccountListHandler = async (isNewAccount = false) => {
        setAccountToLoading(true);
        try {
            const res = await getUserAccountList({
                company_id: StorageService?.getCompanyId(),
                category_id: parseInt(form?.to_account_category),
                sub_category_id: parseInt(form?.to_account_sub_category),
                firm_id: props?.isOpen?.vehicle_firm?._id
            });

            if (res?.responseCode === 200) {
                setAccountToLoading(false);
                const details = res?.data?.account_list?.map((item) => ({
                    ...item,
                    label: item?.name,
                    value: item?._id,
                }));

                setToAccountList(details);

                if (details?.length) {
                    const selectedItem = isNewAccount ? details[details.length - 1] : details[0];

                    setForm((prev) => {
                        const updatedAmount =
                            prev?.sub_category == 2
                                ? prev?.amount || globTripDetails?.freight_summary?.balance || 0
                                : prev?.amount;

                        return {
                            ...prev,
                            to_account_id: selectedItem?.value,
                            amount: updatedAmount,
                        };
                    });

                    setBankRequiredDetails(selectedItem);
                } else {
                    setForm((prev) => ({
                        ...prev,
                        to_account_id: "",
                    }));
                }
            } else {
                setAccountToLoading(false);
                setToAccountList([]);
            }
        } catch (error) {
            setAccountToLoading(false);
            setToAccountList([]);
            console.error("Error fetching to account list:", error);
        }
    };

    const handleOnChange = async (name, value) => {
        const stateObj = {
            ...form,
            [name]: value,
        };

        if (name === "isCheck") {
            stateObj.vendor_account = "";
        }
        setForm(stateObj);

        if (!!formError) {
            const validationResult = await utils.checkFormError(
                { ...stateObj, balance: balance, checkBalance: checkBalance(balance) },
                errorSchema.interFirmFreigthSchema
            );
            if (validationResult === true) {
                setFormError("");
            } else {
                setFormError(validationResult);
            }
        }
    };

    const onSubmitFreight = async (approve) => {
        const validationResult = await utils.checkFormError(
            { ...form, balance: balance, checkBalance: checkBalance(balance) },
            errorSchema.interFirmFreigthSchema,
        );

        const payload = {
            type: form?.category ? parseInt(form?.category) : "",
            sub_type: form?.sub_category ? parseInt(form?.sub_category) : "",
            amount: (form?.amount).toString(),
            date: utils.convertToISO(form?.txn_date, true),
            account_category: form?.account_category
                ? parseInt(form?.account_category)
                : "",
            account_sub_category: form?.account_sub_category
                ? parseInt(form?.account_sub_category)
                : "",
            account_id: form?.account_id ? form?.account_id : "",
            to_account_category: form?.account_category
                ? parseInt(form?.account_category)
                : "",
            to_account_sub_category: form?.account_sub_category
                ? parseInt(form?.account_sub_category)
                : "",
            to_account_id: form?.account_id ? form?.account_id : "",
            description: form?.description,
            vendor_bank_account: bankDetails ? bankDetails?._id : "",
            lr_id: form?.lr_id,
            trip_id: props.tripId,
            branch_id: globTripDetails?.branch_id?._id,
            company_id: form?.company_id,
            vehicle_id: globTripDetails?.vehicle_id?._id,
            is_approval: approve,
            file: form?.file,
            nature_type: form.sub_category == 2 ? checkBalance(balance) === "plus" ? 1 : 2 : 1

        };

        if (validationResult === true) {
            if (approve == 0) {
                setIsLoaddingForSave(true);
            } else {
                setIsLoadding(true);
            }
            setFormError(validationResult);

            try {
                const res = await dispatch(addTransationFreight(payload));
                if (res?.payload?.responseCode === 200) {
                    setIsLoadding(false);
                    setIsLoaddingForSave(false);
                    props?.callBackFreight();
                    closeAll();
                } else {
                    setIsLoadding(false);
                    setIsLoaddingForSave(false);
                }
            } catch {
                setIsLoaddingForSave(false);
                setIsLoadding(false);
            }
        } else {
            setFormError(validationResult);
            setIsLoaddingForSave(false);
            setIsLoadding(false);
        }
    };

    const closeAll = async () => {
        setBankDetails("");
        props?.setIsOpenFreight({ ...props?.isOpenFreight, open: false, type: "" });
        setForm(initiFrom);
    };

    const modifyProps = {
        ...props,
        onSubmit: onSubmitFreight,
        closeModal: closeAll,
        disabled: isLoaddingforsave || isLoadding,
        modalZIndex: modalZIndex,
        isLoaddingforsave: isLoaddingforsave,
        isLoadding: isLoadding,
        saveButton: form?.account_sub_category == 27,
        tripApprovalPermission: bankRequiredDetails?.trip_payment_approval || 0
    };

    const handleFileChange = async (e) => {
        if (
            e?.target?.files[0]?.type === "image/gif" ||
            e?.target?.files[0]?.type === "image/jpeg" ||
            e?.target?.files[0]?.type === "image/png"
        ) {
            setLoading(true);
            try {
                const formData = new FormData();
                formData.append("file", e?.target?.files[0]);
                const res = await uploadFiles(formData);
                if (res?.responseCode === 200) {
                    var fileArray = [];
                    fileArray.push(...form?.file, {
                        filename: res?.data?.filename,
                        path: res?.data?.path,
                    });
                    handleOnChange("file", fileArray);
                    setLoading(false);
                    toast.success("Document added");
                }
            } catch (error) {
                setLoading(false);
            }
        } else {
            toast.error("Invalid file, choose jpeg/png images");
        }
    };

    const documentRemove = (index) => {
        const newFromIput = [...form?.file];
        newFromIput.splice(index, 1);
        setForm({ ...form, file: newFromIput });
    };

    const addAccountHandle = () => {
        setAccountAddShow(true);
    };

    const callBackAddAccount = () => {
        // Determine which account was being added based on current state
        if (accountAddShow) {
            // If adding for "from" account
            if (form?.account_sub_category == 2) {
                getFromAccountListHandler(true);
            }
            // If adding for "to" account
            if (form?.to_account_sub_category == 2) {
                getToAccountListHandler(true);
            }
        }
    };

    let AddTransactionAccountModal = {
        isOpen: accountAddShow,
        closeModal: () => setAccountAddShow(false),
        modalMainClass: "_dashCommon_Modal _mdModal",
        modalTitle: "Add Account",
        footerPart: true,
        submitTitle: "Add Account",
        callBackAddAccount: callBackAddAccount
    };

    const filterFreightList = freigtAccount?.filter((i) =>
        i?.value != (form?.account_sub_category == 2 ? 3 : form?.account_sub_category == 3 ? 2 : "")
    );

    return (
        <div>
            <CommonCanvas {...modifyProps}>
                <div className="offcanvas-body">
                    <div className="_lrCl_offCavBody __otr_expCanva">
                        <div className="_othrExp_recBx">
                            <div className="_clPay_flex">
                                <div className="singleDiv">
                                    <CommonDatePicker
                                        name="date"
                                        label="Transaction Date"
                                        startDate={form?.txn_date}
                                        setStartDate={(data) => {
                                            handleOnChange("txn_date", data);
                                        }}
                                        error={formError?.txn_date}
                                        focus={!!formError?.txn_date}
                                    />
                                </div>

                                {freightTypeList.map((i) => (
                                    <div className="_dualCheckr_bx" key={i?.value}>
                                        <input
                                            className="form-check-input"
                                            id={i?.value}
                                            type="radio"
                                            name="sub_category"
                                            checked={i.value == form.sub_category}
                                            value={i.value}
                                            onChange={({ target: { name, value } }) =>
                                                handleOnChange(name, value)
                                            }
                                        />
                                        <label htmlFor={i?.value} className="form-check-label">
                                            {i?.value == 2 ? checkBalance(balance) == "plus" ? "Pay Balance" : "Receive Balance" : "Pay Advance"}
                                        </label>
                                    </div>
                                ))}

                                <div className="singleDiv">
                                    <CommonInput
                                        label="Description"
                                        name="description"
                                        value={form?.description}
                                        onChange={({ target: { name, value } }) =>
                                            handleOnChange(name, value)
                                        }
                                        focus={!!formError?.description}
                                        error={formError.description}
                                    />
                                </div>

                                <div className="singleDiv">
                                    <CommonInput
                                        label="Amount"
                                        placeholder="Amount"
                                        name="amount"
                                        type="text"
                                        className="__rupeeSymbol"
                                        rupeeSymbol={true}
                                        value={form.amount || ""}
                                        onChange={({ target: { name, value } }) => {
                                            if (/^0[0-9]/.test(value)) {
                                                value = value.replace(/^0+/, '');
                                            }

                                            if (value === "0") {
                                                handleOnChange(name, value);
                                                return;
                                            }
                                            handleOnChange(name, value);
                                        }}
                                        maxLength={10}
                                        onKeyDown={handleKeyDown}
                                        focus={!!formError?.amount}
                                        error={formError.amount}
                                    />
                                </div>
                            </div>
                        </div>

                        {/* From Account Section */}
                        <div className="_othrExp_recBx">
                            <div className="_clPay_flex">
                                <div className="singleDiv">
                                    <div className="_payMode_hed">
                                        <h4>
                                            {props?.isOpen?.vehicle_firm?.firm
                                                ? `Payment Mode for ${props?.isOpen?.branch_firm?.firm}`
                                                : "Payment Mode"}
                                        </h4>
                                        {freigtAccount.map((i) => (
                                            <button
                                                key={i.value}
                                                className={`_baseSpan ${i?.value == form?.account_sub_category
                                                    ? ""
                                                    : "_bspDisable"
                                                    }`}
                                                name="account_sub_category"
                                                disabled={accountLoading}
                                                value={i.value}
                                                onClick={({ target: { value } }) => {
                                                    // ✅ Reset account_id when changing mode
                                                    setForm(prev => ({
                                                        ...prev,
                                                        account_sub_category: value,
                                                        account_id: "" // Reset account
                                                    }));
                                                    setAccountType(value);

                                                    if (value == 2 || value == 27) {
                                                        venderDetailsFun({
                                                            vender_type: 1,
                                                            vender_id: globTripDetails?.supplier_id?._id
                                                        });
                                                    }
                                                }}
                                            >
                                                {i.label}
                                            </button>
                                        ))}
                                    </div>
                                </div>
                                <div className="singleDiv">
                                    {!accountLoading ? (
                                        <CustomSelect
                                            label="Select Account"
                                            // isDropdownTop={true}
                                            name="account_id"
                                            onSelect={(data) => {
                                                handleOnChange("account_id", data.value);
                                                setBankRequiredDetails(data);
                                            }}
                                            value={
                                                form?.account_id
                                                    ? accountList?.find((i) => i.value == form?.account_id)
                                                    : { label: "", value: "" }
                                            }
                                            options={accountList}
                                            focus={!!formError?.account_id}
                                            error={formError.account_id}
                                            isAddButton={form?.account_sub_category == 2}
                                            addButtonAction={addAccountHandle}
                                        />
                                    ) : (
                                        <SkeletonInput isLoading={accountLoading} />
                                    )}
                                </div>

                                <div className="singleDiv">
                                    <CommonInput
                                        label="Transaction Number"
                                        name="Txn_no"
                                        value={form?.Txn_no}
                                        onChange={({ target: { name, value } }) =>
                                            handleOnChange(name, value)
                                        }
                                        focus={!!formError?.Txn_no}
                                        error={formError.Txn_no}
                                    />
                                </div>
                            </div>
                        </div>

                        {/* To Account Section */}
                        <div className="_othrExp_recBx">
                            <div className="_clPay_flex">
                                <div className="singleDiv">
                                    <div className="_payMode_hed">
                                        <h4>
                                            {props?.isOpen?.branch_firm?.firm
                                                ? `Receipt Mode for ${props?.isOpen?.vehicle_firm?.firm}`
                                                : "Receipt Mode"}
                                        </h4>
                                        {filterFreightList.map((i) => (
                                            <button
                                                key={i.value}
                                                className={`_baseSpan ${i?.value == form?.to_account_sub_category
                                                    ? ""
                                                    : "_bspDisable"
                                                    }`}
                                                name="to_account_sub_category"
                                                disabled={accountToLoading}
                                                value={i.value}
                                                onClick={({ target: { value } }) => {
                                                    // ✅ Reset to_account_id when changing mode
                                                    setForm(prev => ({
                                                        ...prev,
                                                        to_account_sub_category: value,
                                                        to_account_id: "" // Reset account
                                                    }));

                                                    if (value == 2 || value == 27) {
                                                        venderDetailsFun({
                                                            vender_type: 1,
                                                            vender_id: globTripDetails?.supplier_id?._id
                                                        });
                                                    }
                                                }}
                                            >
                                                {i.label}
                                            </button>
                                        ))}
                                    </div>
                                </div>
                                <div className="singleDiv">
                                    {!accountToLoading ? (
                                        <CustomSelect
                                            label="Select Account"
                                            // isDropdownTop={true}
                                            name="to_account_id"
                                            onSelect={(data) => {
                                                handleOnChange("to_account_id", data.value);
                                                setBankRequiredDetails(data);
                                            }}
                                            value={
                                                form?.to_account_id
                                                    ? toAccountList?.find((i) => i.value == form?.to_account_id)
                                                    : { label: "", value: "" }
                                            }
                                            options={toAccountList}
                                            focus={!!formError?.to_account_id}
                                            error={formError.to_account_id}
                                            isAddButton={form?.to_account_sub_category == 2}
                                            addButtonAction={addAccountHandle}
                                        />
                                    ) : (
                                        <SkeletonInput isLoading={accountToLoading} />
                                    )}
                                </div>
                            </div>
                        </div>

                        {/* Attachment Section */}
                        <div className="_othrExp_recBx">
                            <div className="_clPay_flex">
                                <div className="singleDiv">
                                    <div className="_attatchmentBxs">
                                        <div className="__addExp_fileBx">
                                            <h4>Attachment</h4>
                                            <input
                                                type="file"
                                                id="_fileUpload"
                                                onClick={(e) => {
                                                    if (form?.file?.length >= 5) {
                                                        e.preventDefault();
                                                        toast.error("You can upload only 5 files");
                                                    }
                                                }}
                                                onChange={(e) => handleFileChange(e)}
                                            />
                                            <label htmlFor="_fileUpload" className="_uploadBtn">
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="20"
                                                    height="19"
                                                    viewBox="0 0 20 19"
                                                    fill="none"
                                                >
                                                    <path
                                                        d="M5 0C6.28846 7.44425e-05 7.52716 0.497542 8.45778 1.38866C9.38839 2.27978 9.93908 3.49575 9.995 4.783L10 5V16C10.0008 16.7809 9.69698 17.5313 9.15323 18.0918C8.60948 18.6523 7.86861 18.9787 7.08804 19.0016C6.30747 19.0245 5.54873 18.7422 4.97303 18.2145C4.39733 17.6869 4.05006 16.9556 4.005 16.176L4 16V6C4.00028 5.74512 4.09788 5.49997 4.27285 5.31463C4.44782 5.1293 4.68695 5.01776 4.94139 5.00283C5.19584 4.98789 5.44638 5.07067 5.64183 5.23426C5.83729 5.39785 5.9629 5.6299 5.993 5.883L6 6V16C6.00028 16.2549 6.09788 16.5 6.27285 16.6854C6.44782 16.8707 6.68695 16.9822 6.94139 16.9972C7.19584 17.0121 7.44638 16.9293 7.64183 16.7657C7.83729 16.6021 7.9629 16.3701 7.993 16.117L8 16V5C8.00075 4.21909 7.69698 3.46867 7.15323 2.90818C6.60948 2.34769 5.86861 2.02132 5.08804 1.9984C4.30747 1.97548 3.54873 2.25784 2.97303 2.78546C2.39733 3.31309 2.05006 4.0444 2.005 4.824L2 5V14C1.99972 14.2549 1.90212 14.5 1.72715 14.6854C1.55218 14.8707 1.31305 14.9822 1.05861 14.9972C0.804163 15.0121 0.553621 14.9293 0.358167 14.7657C0.162714 14.6021 0.0371036 14.3701 0.00699997 14.117L0 14V5C0 3.67392 0.526784 2.40215 1.46447 1.46447C2.40215 0.526784 3.67392 0 5 0ZM13 14H15C15.2549 14.0003 15.5 14.0979 15.6854 14.2728C15.8707 14.4478 15.9822 14.687 15.9972 14.9414C16.0121 15.1958 15.9293 15.4464 15.7657 15.6418C15.6021 15.8373 15.3701 15.9629 15.117 15.993L15 16H13C12.7451 15.9997 12.5 15.9021 12.3146 15.7272C12.1293 15.5522 12.0178 15.313 12.0028 15.0586C11.9879 14.8042 12.0707 14.5536 12.2343 14.3582C12.3979 14.1627 12.6299 14.0371 12.883 14.007L13 14ZM13 10H18.5C18.7549 10.0003 19 10.0979 19.1854 10.2728C19.3707 10.4478 19.4822 10.687 19.4972 10.9414C19.5121 11.1958 19.4293 11.4464 19.2657 11.6418C19.1021 11.8373 18.8701 11.9629 18.617 11.993L18.5 12H13C12.7451 11.9997 12.5 11.9021 12.3146 11.7272C12.1293 11.5522 12.0178 11.313 12.0028 11.0586C11.9879 10.8042 12.0707 10.5536 12.2343 10.3582C12.3979 10.1627 12.6299 10.0371 12.883 10.007L13 10ZM13 6H18.5C18.7549 6.00028 19 6.09788 19.1854 6.27285C19.3707 6.44782 19.4822 6.68695 19.4972 6.94139C19.5121 7.19584 19.4293 7.44638 19.2657 7.64183C19.1021 7.83729 18.8701 7.9629 18.617 7.993L18.5 8H13C12.7451 7.99972 12.5 7.90212 12.3146 7.72715C12.1293 7.55218 12.0178 7.31305 12.0028 7.05861C11.9879 6.80416 12.0707 6.55362 12.2343 6.35817C12.3979 6.16271 12.6299 6.0371 12.883 6.007L13 6ZM13 2H18.5C18.7549 2.00028 19 2.09788 19.1854 2.27285C19.3707 2.44782 19.4822 2.68695 19.4972 2.94139C19.5121 3.19584 19.4293 3.44638 19.2657 3.64183C19.1021 3.83729 18.8701 3.9629 18.617 3.993L18.5 4H13C12.7451 3.99972 12.5 3.90212 12.3146 3.72715C12.1293 3.55218 12.0178 3.31305 12.0028 3.05861C11.9879 2.80416 12.0707 2.55362 12.2343 2.35817C12.3979 2.16271 12.6299 2.0371 12.883 2.007L13 2Z"
                                                        fill="#1956F6"
                                                    />
                                                </svg>
                                                <span>{loading ? "Uploading" : "Add File"}</span>
                                            </label>
                                            {formError?.file && (
                                                <span className="input_drop_error">
                                                    {formError?.file}
                                                </span>
                                            )}
                                        </div>
                                        <div className="img_fnex_src">
                                            {form?.file?.length > 0 &&
                                                form?.file?.map((el, index) => (
                                                    <div className="pos-relative" key={index}>
                                                        <img
                                                            className="_pdfIcon_sigxe"
                                                            src={`${masterData?.s3_url}${el?.path}`}
                                                            alt=""
                                                        />
                                                        <span className="_clDel_icon">
                                                            <IoCloseCircle
                                                                onClick={() => documentRemove(index)}
                                                            />
                                                        </span>
                                                    </div>
                                                ))}
                                        </div>
                                    </div>
                                </div>

                                <div className="singleDiv">
                                    <div className="_balSuccess">
                                        <p>Balance</p>

                                        <p>
                                            {(
                                                (() => {
                                                    const bal = parseFloat(balance) || 0;
                                                    const amt = parseFloat(form?.amount) || 0;
                                                    const updatedAmount = Math.abs(amt);
                                                    return form?.sub_category == 2
                                                        ? bal == 0 ? bal + updatedAmount : (checkBalance(bal) === "minus" ? bal + updatedAmount : bal - updatedAmount)
                                                        : bal - updatedAmount;
                                                })()
                                            ).toFixed(2)}

                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </CommonCanvas>

            {accountAddShow && <AddAccountingAccount {...AddTransactionAccountModal} />}
        </div>
    );
};

export default InterFirmAdvancePay;